import React, { useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import { StepComponentProps } from "../steps";

// Style
import * as S from "../styles";
import { Radio } from "../radio";
import CustomCheckbox from "~/components/ui/Checkbox";
import { Label } from "./styles";
import { useMediaQuery } from "~/hooks/useMediaQuery";

const LAST_STEP = "store-region-radio";

export const REGIONS_ARRAY = [
    {
    id: "aliexpress",
    label: "onboarding.customization-store.region.radio_aliexpress",
    hasTransElem: false,
  },
  {
    id: "us_eu_products",
    label: "onboarding.customization-store.region.radio_us_eu_products",
    hasTransElem: false,
  },
  {
    id: "both",
    label: "onboarding.customization-store.region.radio_both",
    hasTransElem: true,
  },
];

type RegionProps = StepComponentProps & {};

export const Region = ({
  onboardingChoices,
  setOnboardingChoices,
}: RegionProps) => {
  const { t } = useTranslation();
  const isAboveMobile = useMediaQuery("mobileL");

  // List of all region ids except "both"
  const regionIds = REGIONS_ARRAY.filter((r) => r.id !== "both").map(
    (r) => r.id
  );

  // Check if all regions are selected
  const areAllRegionsSelected = () =>
    onboardingChoices?.selectedRegion &&
    Array.isArray(onboardingChoices.selectedRegion) &&
    onboardingChoices.selectedRegion.length === regionIds.length &&
    regionIds.every((id) => onboardingChoices.selectedRegion?.includes(id));

  // Ensure selectedRegion is always an array and default to Aliexpress
  useEffect(() => {
    setOnboardingChoices((prev) => ({
      ...prev,
      selectedRegion: prev?.selectedRegion?.length
        ? prev.selectedRegion
        : ["aliexpress"],
    }));
  }, [setOnboardingChoices]);

  const handleRegionSelect = (regionId: string) => {
    if (regionId === "both") {
      if (areAllRegionsSelected()) {
        setOnboardingChoices((prev) => ({
          ...prev,
          selectedRegion: [],
        }));
      } else {
        setOnboardingChoices((prev) => ({
          ...prev,
          selectedRegion: [...regionIds],
        }));
      }
    } else {
      setOnboardingChoices((prev) => {
        const selected = Array.isArray(prev?.selectedRegion)
          ? [...(prev?.selectedRegion ?? [])]
          : [];
        if (selected.includes(regionId)) {
          return {
            ...prev,
            selectedRegion: selected.filter((id) => id !== regionId),
          };
        } else {
          return {
            ...prev,
            selectedRegion: [...selected, regionId],
          };
        }
      });
    }
  };

  // Ensure selectedRegion is always an array
  useEffect(() => {
    setOnboardingChoices((prev) => ({
      ...prev,
      selectedRegion: prev?.selectedRegion ?? [],
    }));
  }, [setOnboardingChoices]);

  return (
    <S.CardContainer data-testid="region">
      {REGIONS_ARRAY.map((region) => {
        const { id: regionId, label, hasTransElem } = region;
        const checked =
          regionId === "both"
            ? areAllRegionsSelected()
            : Array.isArray(onboardingChoices?.selectedRegion) &&
              onboardingChoices?.selectedRegion?.includes(regionId);

        return (
          <S.CardCategory
            key={`store-region-selection-${regionId}`}
            className={checked ? "active" : ""}
            onClick={() => handleRegionSelect(regionId)}
          >
            <CustomCheckbox
              checked={checked as boolean}
              stopPropagation={true}
              onChange={() => handleRegionSelect(regionId)}
            />
            <Label
              checked={checked as boolean}
              key={`store-region-${regionId}`}>
              {hasTransElem ? (
                <Trans
                  i18nKey={label}
                  components={{
                    1: <span className="all-regions" />,
                  }}
                />
              ) : (
                t(label)
              )}
            </Label>
          </S.CardCategory>
        );
      })}
    </S.CardContainer>
  );
};
